// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__VjFQM","img":"Arrow_img__H8tWz","left":"Arrow_left__1xTLm","right":"Arrow_right__LUIKX","show":"Arrow_show__1d1Kd","hide":"Arrow_hide__1jSgC"};